// extracted by mini-css-extract-plugin
export default {"ratingContainer":"styles_ratingContainer__EIgg9"};